import { _, tinycolor } from "js/vendor";
import * as geom from "js/core/utilities/geom";
import { HorizontalAlignType, VerticalAlignType } from "common/constants";
import Logos from "js/core/models/logos";
import { convertDataURItoBlob } from "js/core/utilities/imageUtilities";
import { uploadBlobToSignedUrl } from "js/core/utilities/uploadBlobToSignedUrl";

export async function GenerateThemeThumbnail(theme) {
    let canvas = document.createElement("canvas");
    canvas.width = 320;
    canvas.height = 180;
    let ctx = canvas.getContext("2d");

    let backgroundColor = tinycolor(theme.colors[theme.defaultBackgroundColor || "background_light"]);
    ctx.fillStyle = backgroundColor.toHexString();
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // decoration
    ctx.fillStyle = theme.colors.theme;
    let lineSize;
    switch (theme.styleWeight) {
        case "light":
            lineSize = 5;
            break;
        case "medium":
            lineSize = 8;
            break;
        case "heavy":
            lineSize = 12;
            break;
    }

    let primaryColor, secondaryColor;
    if (backgroundColor.isDark()) {
        primaryColor = theme.colors.primary_light;
        secondaryColor = theme.colors.secondary_light;
    } else {
        primaryColor = theme.colors.primary_dark;
        secondaryColor = theme.colors.secondary_dark;
    }

    let offsetX = 0;
    let offsetY = 0;
    let offsetHeader = 0;

    switch (theme.styleDecoration) {
        case "bar_left":
            ctx.fillRect(0, 0, lineSize, canvas.height);
            offsetX = 10;
            break;
        case "bar_top_left":
        case "bar_top_center":
            ctx.fillRect(0, 0, canvas.width, lineSize);
            break;
        case "underline_left":
            ctx.fillRect(20, 75, 30, lineSize / 2);
            offsetY = -10;
            break;
        case "underline_center":
            ctx.fillRect(canvas.width / 2 - 40, 75, 80, lineSize / 2);
            offsetY = -10;
            break;
        case "block_left":
        case "block_center":
            ctx.fillRect(0, 0, canvas.width, 77);
            if (tinycolor(theme.colors.theme).isDark()) {
                primaryColor = theme.colors.primary_light;
            } else {
                primaryColor = theme.colors.primary_dark;
            }
            offsetY = -15;
            break;
    }

    ctx.fillStyle = primaryColor;
    ctx.font = `${theme.fontHeaderWeight} 50px ${theme.fontHeaderFontId}`;
    ctx.textAlign = theme.styleDecoration.contains("center") ? "center" : "left";
    let textX;
    if (theme.styleDecoration.contains("center")) {
        textX = canvas.width / 2;
    } else {
        textX = 20 + offsetX;
    }
    ctx.textBaseline = "middle";
    ctx.fillText("Header", textX, 60 + offsetY);

    ctx.fillStyle = secondaryColor;
    ctx.font = `${theme.fontBodyWeight} 20px ${theme.fontBodyFontId}`;
    ctx.fillText("This is the body text", textX, 100);

    for (let i = 0; i < 10; i++) {
        let color;
        if (i == 0) {
            color = theme.colors.theme;
        } else if (Object.keys(theme.colors).contains(`accent${i}`)) {
            color = theme.colors[`accent${i}`];
        }
        if (color) {
            ctx.beginPath();
            ctx.fillStyle = color;
            ctx.strokeStyle = "#ccc";
            ctx.arc(30 + i * 25 + offsetX, 155, 10, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
        }
    }

    if (theme.logo || theme.logoDark) {
        await new Promise(async resolve => {
            let logo = new Image();
            logo.crossOrigin = "anonymous";
            logo.onload = () => {
                let bounds = new geom.Rect(0, 0, 130, 50).alignInContainer(new geom.Rect(0, 0, canvas.width, canvas.height), HorizontalAlignType.RIGHT, VerticalAlignType.BOTTOM).offset(-10, -10);
                let imageRect = new geom.Rect(0, 0, logo.naturalWidth, logo.naturalHeight).fitToSize(bounds).alignInContainer(bounds, HorizontalAlignType.CENTER, VerticalAlignType.CENTER);
                // ctx.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
                ctx.drawImage(logo, imageRect.x, imageRect.y, imageRect.width, imageRect.height);
                resolve();
            };
            logo.src = await Logos.getSignedUrlAndLoad(backgroundColor.isDark() ? theme.logo_dark : theme.logo, true);
        });
    }

    return new Promise(resolve => {
        canvas.toBlob(async blob => {
            // upload the image
            const id = `${theme.id}-${new Date().getTime().toString()}.png`;
            const writeUrl = await Logos.getWriteSignedUrl(id);
            await uploadBlobToSignedUrl(blob, writeUrl);
            resolve(id);
        });
    });
}
